import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const LoadingDisplay = ({ message = "Loading...", height = "60vh" }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: height,
        width: "100%",
      }}
    >
      <CircularProgress aria-label={message} />
      {message && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingDisplay;
